<template functional>
  <div class="py-6 w-full h-full flex flex-col items-center justify-center">
    <div
      v-if="props.saveStatus === 'pending'"
      class="bg-green-500 text-white dark:text-dark-900 shadow-lg my-6 rounded-lg w-10/12 md:w-3/4 lg:w-2/3 p-3"
    >
      <h1 class="font-heading text-3xl py-3">Saving Result</h1>
      <p class="pb-2">Please Wait</p>
    </div>

    <div
      v-if="props.saveStatus === 'failed'"
      class="bg-red-700 shadow-lg text-white dark:text-dark-900 my-6 rounded-lg w-10/12 md:w-3/4 lg:w-2/3 p-3"
    >
      <h1 class="font-heading text-3xl py-3">Problem Saving Result</h1>
      <p class="pb-2">
        Please Take A Note Of Your Score And Email It To
        lockdownorienteering@gmail.com
      </p>
    </div>

    <h1 class="font-semibold font-heading text-5xl my-2">Well Done!</h1>
    <h2 class="font-semibold font-main text-2xl mt-3">
      Score: {{ props.score }}
    </h2>
    <h2 class="font-semibold font-main text-2xl mb-3">
      Time: {{ props.time / 1000 }}s
    </h2>
    <div>
      <router-link class="button-secondary mx-2 mt-4 inline-block" to="/"
        >Return Home</router-link
      >

      <a
        v-if="props.saveStatus !== ''"
        href="https://www.maprunner.co.uk/lockdown-results/"
        class="button-secondary mx-2 mt-4 inline-block"
        >View Results</a
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    score: {
      type: String,
      default: '',
    },
    time: {
      type: Number,
      default: 0,
    },
    saveStatus: {
      type: String,
      default: '',
    },
  },
}
</script>
